// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".setting_config[data-v-074c8b42] {\n  margin-bottom: 16px;\n  display: grid;\n  grid-template-columns: 0.3fr 1fr;\n}\n", ""]);
// Exports
module.exports = exports;
